// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__svkAP","right":"styles_right__1FieX"};